module.exports = __webpack_public_path__ + "media/images/flags/4x3/nga-1b00f0e40bf6671968bebdc46e604561.svg";